var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"placeholder":"中分類"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.opt中分類s),function(o){return _c('el-option',{key:o,attrs:{"label":o,"value":o}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }